const routes = [
  {
    path: "/manutencao-do-nivel-curso",
    name: "manutencao-do-nivel-curso",
    meta: {
      allowedPermissions: ["nivel_curso_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoDoNivelCursos/ManutencaoDoNivelCursosHome.vue"),
  },
  {
    path: "/manutencao-do-nivel-curso/novo",
    name: "manutencao-do-nivel-curso-novo",
    meta: {
      allowedPermissions: ["nivel_curso_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoDoNivelCursos/ManutencaoDoNivelCursosCad.vue"),
  },
  {
    path: "/manutencao-do-nivel-curso/editar/:id",
    name: "manutencao-do-nivel-curso-editar",
    meta: {
      allowedPermissions: ["nivel_curso_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import("@/views/ManutencaoDoNivelCursos/ManutencaoDoNivelCursosEdit.vue"),
  },
];

export default routes;
